(() => {
  const LIMIT = 30000;
  const MESSAGE = 'Unable to add as it would exceed the 30 kg order limit.\nPlease review your cart and reduce quantities to continue.';
  const CHECKOUT_MESSAGE = 'Your cart exceeds the 30 kg order limit. Please reduce the quantity to continue.';
  const base = window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  let dismissNotice;
  const grams = item => item.requires_shipping === false ? 0 : Math.max(0, Number(item.grams) || 0);
  const total = cart => cart.items.reduce((sum, item) => sum + grams(item) * item.quantity, 0);
  const identity = item => JSON.stringify([String(item.variant_id || item.id), Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b)), String(item.selling_plan_allocation?.selling_plan.id || item.selling_plan || '')]);
  const match = (cart, item) => cart.items.find(line => identity(line) === identity(item));
  const fromControls = controls => {
    const properties = JSON.parse(controls.dataset.lineProperties || '{}');
    return {variant_id:controls.dataset.lineVariant,properties:Array.isArray(properties) ? Object.fromEntries(properties) : properties,selling_plan:controls.dataset.linePlan || ''};
  };
  function sync(cart) {
    const form = document.querySelector('.refined-bag .cart-form');
    if (!form) return;
    const format = cents => new Intl.NumberFormat('en',{style:'currency',currency:cart.currency,maximumFractionDigits:0}).format(cents / 100);
    form.querySelectorAll('.bag-item-controls').forEach(controls => {
      const item = match(cart, fromControls(controls));
      if (!item) return;
      const input = controls.querySelector('input');
      input.value = item.quantity;
      input.dataset.savedQuantity = item.quantity;
      const link = controls.querySelector('a.remove'), url = new URL(link.href);
      url.searchParams.set('id',item.key);
      link.href = url.pathname + url.search;
      const amount = controls.closest('.cart-line').querySelector('.bag-item-price [data-money]');
      if (amount) { amount.dataset.money = item.final_line_price; amount.textContent = format(item.final_line_price); }
    });
    const amount = form.querySelector('.bag-total [data-money]');
    if (amount) { amount.dataset.money = cart.total_price; amount.textContent = format(cart.total_price); }
    document.querySelectorAll('.header-bag-count').forEach(el => el.textContent = cart.item_count);
    document.querySelector('.cart-link')?.setAttribute('aria-label', 'Shopping cart, ' + cart.item_count + ' items');
    window.districtCurrency?.render();
  }
  const read = async () => {
    const response = await fetch(base + 'cart.js', {cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw Error('Unable to check your cart. Please try again.');
    return response.json();
  };
  function serialize(run) {
    const next = queue.then(() => navigator.locks?.request ? navigator.locks.request('dstrct05-cart-weight', run) : run());
    queue = next.catch(() => {});
    return next;
  }
  function rejected(message = MESSAGE) {
    return new Response(JSON.stringify({status:422,code:'cart_weight_limit',description:message}), {status:422,headers:{'Content-Type':'application/json'}});
  }
  function projected(cart, operation, data, metadata) {
    let next = total(cart);
    if (operation === 'add') {
      for (const addition of data.items || [data]) {
        const item = metadata.find(m => String(m.variant_id || m.id) === String(addition.id)) || cart.items.find(m => String(m.variant_id) === String(addition.id));
        if (!item || typeof item.requires_shipping !== 'boolean' || (item.requires_shipping && !Number.isFinite(Number(item.grams)))) throw Error('Unable to check this item. Please refresh and try again.');
        next += grams(item) * Number(addition.quantity || 1);
      }
    } else if (operation === 'change') {
      const item = cart.items.find(m => m.key === String(data.id) || String(m.variant_id) === String(data.id)) || (metadata[0] && match(cart,metadata[0]));
      if (!item) throw Error('Your cart has changed. Please refresh and try again.');
      next += grams(item) * (Number(data.quantity) - item.quantity);
    }
    return next;
  }
  function request(url, options, metadata = []) {
    dismissNotice?.();
    return serialize(async () => {
      const cart = await read();
      const data = options.body instanceof FormData ? Object.fromEntries(options.body.entries()) : JSON.parse(options.body);
      const operation = /cart\/add/.test(url) ? 'add' : 'change';
      const next = projected(cart, operation, data, metadata);
      if (next > LIMIT && next > total(cart)) return rejected();
      if (data.return_to === '/checkout' && next > LIMIT) return rejected(CHECKOUT_MESSAGE);
      if (operation === 'change') {
        const item = cart.items.find(line => line.key === String(data.id)) || (metadata[0] && match(cart,metadata[0]));
        if (!item) throw Error('Your cart has changed. Please refresh and try again.');
        data.id = item.key;
        options = {...options,body:JSON.stringify(data)};
      }
      const response = await fetch(url, options);
      if (operation === 'change') {
        const latest = await read();
        sync(latest);
        if (response.ok) return new Response(JSON.stringify(latest),{headers:{'Content-Type':'application/json'}});
        const target = cart.items.find(line => line.key === data.id);
        const saved = match(latest,target);
        if ((saved?.quantity || 0) === Number(data.quantity)) return new Response(JSON.stringify(latest),{headers:{'Content-Type':'application/json'}});
      }
      return response;
    });
  }
  function notice(anchor, message = MESSAGE) {
    dismissNotice?.();
    let host = anchor;
    const rect = host?.getBoundingClientRect();
    if (rect && (rect.bottom < 60 || rect.top > innerHeight)) {
      const dock = document.querySelector('[data-mobile-dock]:not([hidden]) [data-dock-add], [data-mobile-dock]:not([hidden]) [data-dock-checkout]');
      if (dock) host = dock;
      else host?.scrollIntoView({block:'center',behavior:'smooth'});
    }
    if (!host) return;
    const box = document.createElement('span');
    box.id = 'CartWeightNotice';
    box.className = 'cart-weight-note';
    box.setAttribute('role','status');
    box.textContent = message;
    const describedBy = host.getAttribute('aria-describedby');
    host.setAttribute('aria-describedby', [describedBy, box.id].filter(Boolean).join(' '));
    (host.closest('dialog[open]') || document.body).append(box);
    const position = () => {
      const bounds = host.getBoundingClientRect();
      box.hidden = bounds.bottom <= 0 || bounds.top >= innerHeight;
      const left = Math.max(12, Math.min(bounds.left + bounds.width / 2 - box.offsetWidth / 2, innerWidth - box.offsetWidth - 12));
      const above = bounds.top - box.offsetHeight - 7;
      const top = above >= 64 ? above : bounds.bottom + 7;
      box.style.left = left + 'px';
      box.style.top = Math.max(12, Math.min(top, innerHeight - box.offsetHeight - 12)) + 'px';
    };
    const dismiss = () => {
      clearTimeout(timer);
      box.remove();
      if (describedBy) host.setAttribute('aria-describedby', describedBy);
      else host.removeAttribute('aria-describedby');
      window.removeEventListener('scroll', position, true);
      window.removeEventListener('resize', position);
      if (dismissNotice === dismiss) dismissNotice = null;
    };
    const timer = setTimeout(dismiss, 6500);
    dismissNotice = dismiss;
    window.addEventListener('scroll', position, true);
    window.addEventListener('resize', position);
    position();
  }
  const approved = new WeakSet();
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.cart-form, .summary-checkout-form') || event.submitter?.name !== 'checkout') return;
    if (approved.has(form)) { approved.delete(form); return; }
    event.preventDefault();
    const button = event.submitter;
    try {
      const allowed = await serialize(async () => total(await read()) <= LIMIT);
      if (!allowed) { notice(button, CHECKOUT_MESSAGE); return; }
      approved.add(form);
      form.requestSubmit(button);
    } catch(error) { notice(button, error.message); }
  });
  window.addEventListener('focus', () => { if (document.querySelector('.cart-form') && !document.querySelector('.cart-form[aria-busy="true"]')) read().then(sync).catch(() => {}); });
  window.districtCartWeight = {request, notice, total, projected, read, sync, fromControls, match, limit:LIMIT, message:MESSAGE};
})();
